export const useApiAdvertisersIdModelsTranslationKeys = {
  offerModelsOfferRulesAreNotAccepted: 'offer.models-offer-rules-are-not-accepted',
  offerModelsOfferStatusIsInactive: 'offer.models-offer-status-is-inactive',
  offerModelsOfferStatusWorkingConditionsAreNotAccepted: 'offer.models-offer-status-working-conditions-are-not-accepted',
}
